import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function SoundFill(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.358 2.648c.04.04.08.082.147.16.09.102.215.253.364.45.297.397.688.985 1.078 1.765.78 1.561 1.553 3.887 1.553 6.973 0 3.087-.772 5.413-1.553 6.974-.39.78-.781 1.368-1.078 1.764a7.718 7.718 0 01-.364.451 3.658 3.658 0 01-.15.164.5.5 0 01-.71-.705l.002-5.801a9.62 9.62 0 01-.7 1.877 7.889 7.889 0 01-.76 1.234c-.171.228-.497.232-.7.03l-.045-.046a.47.47 0 01-.03-.617c.172-.228.406-.578.64-1.048.47-.94.948-2.363.948-4.277 0-1.913-.478-3.337-.947-4.276a6.887 6.887 0 00-.64-1.049c-.138-.182-.137-.435.02-.594l.043-.044a.498.498 0 01.736.038c.204.272.47.672.735 1.202C17.477 8.334 18 9.91 18 11.996c0 1.088-.142 2.036-.353 2.846v5.8l.003-.002.019-.02.084-.094c.074-.084.183-.215.316-.392.265-.354.624-.891.984-1.611.72-1.44 1.447-3.613 1.447-6.527 0-2.913-.728-5.087-1.447-6.526-.36-.72-.719-1.257-.984-1.611a6.764 6.764 0 00-.4-.485l-.02-.02-.003-.004-.058-.07a.5.5 0 01.058-.637.509.509 0 01.712.005zM9.793 4.704c.63-.63 1.707-.184 1.707.707v13.171c0 .891-1.077 1.337-1.707.707l-3-3a1 1 0 00-.707-.293H3.5a1 1 0 01-1-1v-6a1 1 0 011-1h2.586a1 1 0 00.707-.292l3-3zm4.06 3.939l.002.001c.073.075.139.156.201.24.11.146.251.36.391.639.28.56.553 1.387.553 2.473 0 1.087-.272 1.913-.553 2.474a4.19 4.19 0 01-.39.639 2.908 2.908 0 01-.203.24.5.5 0 01-.71-.704l.023-.025c.02-.022.05-.06.09-.111a3.2 3.2 0 00.296-.486c.22-.44.447-1.113.447-2.027 0-.913-.228-1.587-.447-2.026a3.197 3.197 0 00-.297-.486 1.916 1.916 0 00-.11-.134.506.506 0 010-.707.5.5 0 01.708 0z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SoundFill);
export default ForwardRef;